import {
  put,
  all,
} from 'redux-saga/effects';
import * as baseTypes from './base/types';
import * as dimensionDataTypes from './dimensionData/types';
import * as benchmarkDataTypes from './benchmark/types';
import * as metricsDataTypes from './metricsData/types';
import * as kpiDataTypes from './kpiData/types';
import * as widgetMessageDataTypes from './widgetMessageData/types';
import * as audienceMetricsDataTypes from './audienceMetrics/types';
import * as spiThresholdsDataTypes from './spiThresholds/types';
import * as impactedViewersTypes from './impactedViewers/types';

import { sagas as baseSagas } from './base';
import { sagas as dimensionDataSagas } from './dimensionData';
import { sagas as benchmarkSagas } from './benchmark';
import { sagas as metricsDataSagas } from './metricsData';
import { sagas as spiDataSagas } from './kpiData';
import { sagas as widgetMessageDataSagas } from './widgetMessageData';
import { sagas as audienceMetricSagas } from './audienceMetrics';
import { sagas as spiThresholdSagas } from './spiThresholds';

import { sagas as sharingSagas } from './sharing';
import { sagas as savedDashboardSagas } from './dashboard';
import { sagas as tempDashboardSagas } from './tempDashboard';
import { sagas as impactedViewersSagas } from './impactedViewers';

function* init() {
  yield all([
    put({ type: baseTypes.INIT }),
    put({ type: dimensionDataTypes.INIT }),
    put({ type: benchmarkDataTypes.INIT }),
    put({ type: metricsDataTypes.INIT }),
    put({ type: kpiDataTypes.INIT }),
    put({ type: widgetMessageDataTypes.INIT }),
    put({ type: audienceMetricsDataTypes.INIT}),
    put({ type: spiThresholdsDataTypes.INIT}),
    put({ type: impactedViewersTypes.INIT}),
  ]);
}

export default [
  init,
  ...baseSagas,
  ...dimensionDataSagas,
  ...benchmarkSagas,
  ...metricsDataSagas,
  ...spiDataSagas,
  ...widgetMessageDataSagas,
  ...audienceMetricSagas,
  ...spiThresholdSagas,
  ...sharingSagas,
  ...savedDashboardSagas,
  ...tempDashboardSagas,
  ...impactedViewersSagas,
];
